import { render, staticRenderFns } from "./RangeSlider.vue?vue&type=template&id=60b9b942"
import script from "./RangeSlider.vue?vue&type=script&lang=js"
export * from "./RangeSlider.vue?vue&type=script&lang=js"
import style0 from "./RangeSlider.vue?vue&type=style&index=0&id=60b9b942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports